<template>
  <!-- replace the below <div class="d-flex flex-column bg-light"> with <body class="d-flex flex-column bg-light"> -->
  <div class="d-flex flex-column bg-light">
    <Header />
    <div class="sticky-top">
      <div style="min-height: 0.4rem" class="bg-secondary">
        <div id="pageProgress" class="progress indeterminate hidden">
          <div class="progress-bar bg-secondary"></div>
        </div>
      </div>
      <nav
        class="navbar navbar-expand-lg navbar-dark bg-primary elevate flex-shrink-0"
      >
        <a class="navbar-brand text-alt-secondary mr-5" href="#"
          >Private Facilities Search</a
        >
      </nav>
    </div>
    <main class="flex-fill pl-3 pr-3 pb-3">
      <div class="jumbotron elevate bg-white pt-2 rounded">
        <div class="">          
          <SearchForm />
        </div>
      </div>
    </main>
    <Footer />
  </div>
</template>

<script>
import SearchForm from "../components/SearchForm";
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";

export default {
  name: "App",
  components: {
    SearchForm,
    Header,
    Footer,
  },
};
</script>